import { useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { SimpleModal } from "../SimpleModal/SimpleModal";
import { ActionDetailContent } from "../../../TeamReport/ActionDetailModal/ActionDetailModal";
import { useLeagueEnvironment } from "../../../data/LeagueEnvironmentProvider";
import { ExplorerEnvironment } from "../../../data/Cache";
import { ActionDetailResponse } from "../../../TeamReport/ActionDetailModal/types";
import "../../../TeamReport/ShotDetailModal/ShotDetailModal.scss";
import "../../../TeamReport/DetailModal/DetailModal.scss";

interface ActionDetailChartDialogProps {
  data: ActionDetailResponse;
  isOpen: boolean;
  handleClose: () => void;
  title: string;
}

export default function ActionDetailChartDialog({
  data,
  isOpen,
  handleClose,
  title,
}: ActionDetailChartDialogProps) {
  const environment = useLeagueEnvironment();
  const showCollegeLine = environment === ExplorerEnvironment.DRAFT;

  const onClose = useCallback(
    (_event: object, _reason: string) => {
      handleClose();
    },
    [handleClose]
  );

  if (data.actions.length === 0) {
    return (
      <SimpleModal
        isOpen={isOpen}
        handleClose={onClose}
        title={title}
        maxWidth="xl"
        dialogClassName="detail-modal--dialog"
      >
        <Box className="empty-state">
          <Typography color="text.secondary">
            No actions found for this query.
          </Typography>
        </Box>
      </SimpleModal>
    );
  }

  return (
    <SimpleModal
      isOpen={isOpen}
      handleClose={onClose}
      title={title}
      maxWidth="xl"
      dialogClassName="detail-modal--dialog"
    >
      <ActionDetailContent
        showCollegeLine={showCollegeLine}
        directData={data}
      />
    </SimpleModal>
  );
}
